export default {
    getCurrentChannel: (state) => {
        return state.currentChannel
    },
    getIsOpenChat: (state) => {
        return state.isOpenChat
    },
    getClosingChannel: (state) => {
        return state.closingChannel
    },
    getActiveChannels: (state) => {
        return state.activeChannels
    },
    getSelectedDriverChannel: (state) => {
        return state.selectedDriverChannel
    },
    getChatOpenedBy: (state) => {
        return state.chatOpenedByOperator
    },
}
